"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Yup = _interopRequireWildcard(require("yup"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _reactI18next = require("react-i18next");

var _formik = require("formik");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Input = _interopRequireDefault(require("../Input"));

var _Button = _interopRequireDefault(require("../Button"));

var _default = function _default(_ref) {
  var domain = _ref.domain,
      isLoading = _ref.isLoading,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    initialValues: {
      domain: ''
    },
    onSubmit: function onSubmit() {
      return onConfirm();
    },
    validationSchema: Yup.object().shape({
      domain: Yup.string().oneOf([domain]).required()
    }),
    render: function render(_ref2) {
      var errors = _ref2.errors,
          dirty = _ref2.dirty,
          handleSubmit = _ref2.handleSubmit;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "p-8 bg-card"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between pb-2"
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "text-3xl font-bold dark:text-dark"
      }, t('settings.domain.disconnect.confirm.title')), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: onClose,
        className: "text-gray-medium hover:text-gray-dark"
      }, /*#__PURE__*/_react["default"].createElement(_Close["default"], {
        fontSize: "large"
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-gray-light text-sm font-bold"
      }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18nKey: "settings.domain.disconnect.confirm.description",
        values: {
          domain: domain
        }
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "mb-1"
      })), /*#__PURE__*/_react["default"].createElement("p", {
        className: "mt-4 mb-4"
      }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18nKey: "settings.domain.disconnect.confirm.label",
        values: {
          domain: domain
        }
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "text-medium"
      })))), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        name: "domain",
        autoComplete: "off",
        disabled: isLoading,
        className: "w-full font-bold !border-none",
        placeholder: t('settings.domain.disconnect.confirm.placeholder')
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "mt-6"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        type: "button",
        color: "secondary",
        onClick: onClose,
        className: "mr-2 w-32"
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        size: "sm",
        color: "warning",
        className: "w-56",
        onClick: handleSubmit,
        disabled: !(0, _isEmpty["default"])(errors) || !dirty || isLoading
      }, t('settings.domain.disconnect.title'))));
    }
  });
};

exports["default"] = _default;
//# sourceMappingURL=index.js.map